import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { MdAdd, MdRemove } from 'react-icons/md';
import styled, { css } from 'styled-components';
import { FormattedNumber, FormattedMessage } from '@techstyle/react-intl';
import Checkbox from '../Checkbox';
import Collapsible from '../Collapsible';
import Heading from '../Heading';
import { FilterFieldLabelProvider, OptionLabelProvider, LabelType } from '../LabelProvider';
import { useProductFilters } from '../ProductFilterContext';
import { useProductFilters as useProductFiltersCustomFilters } from '../ProductFilterContextCustomFilters';
import ProductSizeFilter from '../ProductSizeFilter';
import Section from '../Section';
import { desktop, mobile } from '../styles';
import useBreakpoint from '../useBreakpoint';
import useId from '../useId';
import slugify from '../utils/slugify';
import { ProductListingFilterStyle } from './constants';
var Wrapper = styled.div.withConfig({
  displayName: "ProductListingFilter__Wrapper",
  componentId: "sc-o02ape-0"
})(["\n  box-shadow: inset 0 1px 0 0 #eee;\n\n  :last-child {\n    box-shadow: 0 1px 0 0 #eee, 0 -1px 0 0 #eee;\n  }\n"]);
var FilterFieldButton = styled(Collapsible.Button).withConfig({
  displayName: "ProductListingFilter__FilterFieldButton",
  componentId: "sc-o02ape-1"
})(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 19px 16px;\n  text-align: left;\n\n  ", "\n\n  ", ";\n"], desktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 12px 8px;\n  "]))), _ref => {
  var $filterFieldButtonStyle = _ref.$filterFieldButtonStyle;
  return $filterFieldButtonStyle;
});
var FilterFieldLabel = styled.span.withConfig({
  displayName: "ProductListingFilter__FilterFieldLabel",
  componentId: "sc-o02ape-2"
})(["\n  font-size: 16px;\n  color: #333;\n\n  ", "\n  ", ";\n"], desktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 14px;\n    "]))), _ref2 => {
  var labelContainerStyle = _ref2.labelContainerStyle;
  return labelContainerStyle;
});
var FilterFieldLabelText = styled.span.withConfig({
  displayName: "ProductListingFilter__FilterFieldLabelText",
  componentId: "sc-o02ape-3"
})(["\n  ", ";\n"], _ref3 => {
  var labelStyle = _ref3.labelStyle;
  return labelStyle;
});
var FilterValueSummary = styled.span.withConfig({
  displayName: "ProductListingFilter__FilterValueSummary",
  componentId: "sc-o02ape-4"
})(["\n  color: #999;\n  ", ";\n"], _ref4 => {
  var filterCountStyle = _ref4.filterCountStyle;
  return filterCountStyle;
});
var FilterList = styled.ul.withConfig({
  displayName: "ProductListingFilter__FilterList",
  componentId: "sc-o02ape-5"
})(["\n  padding-left: ", "px;\n  padding-bottom: ", "px;\n  padding-top: 6px;\n  list-style: none;\n\n  ", "\n\n  ", ";\n"], _ref5 => {
  var depth = _ref5.depth;
  return depth > 0 ? 8 : 24;
}, _ref6 => {
  var depth = _ref6.depth;
  return depth > 0 ? 4 : 12;
}, desktop(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    padding-left: 16px;\n    padding-left: ", "px;\n    padding-bottom: 16px;\n  "])), _ref7 => {
  var depth = _ref7.depth;
  return depth > 0 ? 8 : 16;
}), _ref8 => {
  var listStyle = _ref8.listStyle;
  return listStyle;
});
var FilterWrappedList = styled.ul.withConfig({
  displayName: "ProductListingFilter__FilterWrappedList",
  componentId: "sc-o02ape-6"
})(["\n  padding-left: ", "px;\n  padding-bottom: ", "px;\n  padding-top: 6px;\n  list-style: none;\n\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  flex-wrap: wrap;\n\n  ", "\n\n  ", ";\n"], _ref9 => {
  var depth = _ref9.depth;
  return depth > 0 ? 8 : 24;
}, _ref10 => {
  var depth = _ref10.depth;
  return depth > 0 ? 4 : 12;
}, desktop(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    padding-left: 16px;\n    padding-left: ", "px;\n    padding-bottom: 16px;\n  "])), _ref11 => {
  var depth = _ref11.depth;
  return depth > 0 ? 8 : 16;
}), _ref12 => {
  var listStyle = _ref12.listStyle;
  return listStyle;
});
var checkmarkStyle = css(["\n  font-size: 12px;\n  color: #ddd;\n  visibility: visible;\n\n  ", "\n"], mobile(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["font-size: 14px;"]))));
var checkmarkCheckedStyle = css(["\n  color: #333;\n"]);
var checkmarkCheckingStyle = css(["\n  opacity: 1;\n  color: #aaa;\n"]);
var checkmarkDisabledStyle = css(["\n  color: #333;\n"]);
var gridCheckmarkStyle = css(["\n  display: none;\n"]);
var inputCheckedStyle = css(["\n  background: none;\n"]);
var gridInputCheckedStyle = css(["\n  background: #eee;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16);\n  border: solid 2px #333;\n"]);
var FilterCheckbox = styled(Checkbox).attrs(props => {
  return {
    checkmarkStyle: props.checkmarkStyle || checkmarkStyle,
    checkmarkCheckedStyle: props.checkmarkCheckedStyle || checkmarkCheckedStyle,
    checkmarkCheckingStyle: props.checkmarkCheckingStyle || checkmarkCheckingStyle,
    checkmarkDisabledStyle: props.checkmarkDisabledStyle || checkmarkDisabledStyle,
    inputCheckedStyle: props.inputCheckedStyle || inputCheckedStyle
  };
}).withConfig({
  displayName: "ProductListingFilter__FilterCheckbox",
  componentId: "sc-o02ape-7"
})(["\n  padding: 2px;\n  margin: 0 6px 0 2px;\n  border: none;\n"]);
var FilterItem = styled.li.withConfig({
  displayName: "ProductListingFilter__FilterItem",
  componentId: "sc-o02ape-8"
})(["\n  display: flex;\n  align-items: center;\n  list-style: none;\n  padding: 8px 0;\n  ", ";\n\n  ", "\n\n  ", ";\n"], _ref13 => {
  var disabled = _ref13.disabled,
      disabledItemStyle = _ref13.disabledItemStyle;
  return disabled && "\n    opacity: 0.32;\n    ".concat(disabledItemStyle, ";\n  ");
}, desktop(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    padding: 4px 0;\n  "]))), _ref14 => {
  var itemStyle = _ref14.itemStyle;
  return itemStyle;
});
var FilterItemLabel = styled.label.withConfig({
  displayName: "ProductListingFilter__FilterItemLabel",
  componentId: "sc-o02ape-9"
})(["\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  text-align: left;\n  color: #333;\n  padding: 4px 0;\n\n  ", "\n\n  ", ";\n"], mobile(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    padding-left: 4px;\n  "]))), _ref15 => {
  var itemLabelStyle = _ref15.itemLabelStyle;
  return itemLabelStyle;
});
var CircleIcon = styled.span.withConfig({
  displayName: "ProductListingFilter__CircleIcon",
  componentId: "sc-o02ape-10"
})(["\n  display: ", ";\n  flex: 0 0 auto;\n  height: 24px;\n  width: 24px;\n  margin-right: 8px;\n  border-radius: 28px;\n  ", ";\n  background: ", ";\n  box-shadow: ", ";\n\n  ", ";\n\n  ", ";\n"], _ref16 => {
  var colorSwatches = _ref16.colorSwatches,
      value = _ref16.value;
  return colorSwatches[value] ? 'block' : 'none';
}, _ref17 => {
  var backgroundImage = _ref17.backgroundImage;
  return backgroundImage && "background-image: url(".concat(backgroundImage, ")");
}, _ref18 => {
  var value = _ref18.value,
      colorSwatches = _ref18.colorSwatches;
  return "".concat(colorSwatches[value]);
}, _ref19 => {
  var showBorder = _ref19.showBorder;
  return showBorder && 'inset 0 0 0 1px #333';
}, desktop(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    height: 16px;\n    width: 16px;\n  "]))), _ref20 => {
  var circleIconStyle = _ref20.circleIconStyle;
  return circleIconStyle;
});
var SwatchGridFilterItem = styled.li.withConfig({
  displayName: "ProductListingFilter__SwatchGridFilterItem",
  componentId: "sc-o02ape-11"
})(["\n  justify-content: center;\n\n  &:hover ", " {\n    ", ";\n  }\n\n  ", " {\n    width: 32px;\n    height: 32px;\n    ", ";\n\n    ", ";\n  }\n\n  ", " {\n    flex-direction: column;\n    cursor: pointer;\n    gap: 6px;\n\n    ", "\n\n    ", " {\n      margin: 0;\n    }\n  }\n\n  ", " {\n    display: none;\n  }\n\n  margin-right: 8px;\n\n  ", ";\n"], CircleIcon, _ref21 => {
  var isChecked = _ref21.isChecked,
      disabled = _ref21.disabled;
  return !isChecked && !disabled && "\n        border: 2px solid #fff;\n        box-shadow: 0 0 0 1px #18181E;\n    ";
}, CircleIcon, _ref22 => {
  var isChecked = _ref22.isChecked;
  return isChecked && "\n      border: 2px solid #fff;\n      box-shadow: 0 0 0 2px #18181E;\n    ";
}, _ref23 => {
  var disabled = _ref23.disabled,
      colorValue = _ref23.colorValue,
      colorSwatches = _ref23.colorSwatches,
      disabledItemStyle = _ref23.disabledItemStyle;
  return disabled && "\n      opacity: 0.3;\n      background: linear-gradient(135deg, ".concat(colorSwatches[colorValue], " calc(50% - 1px), #E5E4F4 50%, ").concat(colorSwatches[colorValue], " calc(50% + 1px));\n      color: #70758C;\n      cursor: not-allowed;\n\n      ").concat(disabledItemStyle, ";\n    ");
}, FilterItemLabel, _ref24 => {
  var disabled = _ref24.disabled;
  return disabled && "\n      color: #70758C;\n      cursor: not-allowed;\n    ";
}, CircleIcon, FilterCheckbox, _ref25 => {
  var itemStyle = _ref25.itemStyle;
  return itemStyle;
});
var TagsGridFilterItem = styled.li.withConfig({
  displayName: "ProductListingFilter__TagsGridFilterItem",
  componentId: "sc-o02ape-12"
})(["\n  display: flex;\n  margin: 0 8px 8px 0;\n\n  ", " {\n    display: none;\n  }\n\n  ", " {\n    height: 40px;\n    padding: 8px 16px 8px 16px;\n    border-radius: 48px;\n    border: 1px solid #ededf0;\n    cursor: pointer;\n    font-weight: 400;\n\n    &:hover {\n      ", ";\n    }\n\n    ", ";\n\n    ", ";\n  }\n\n  ", ";\n"], FilterCheckbox, FilterItemLabel, _ref26 => {
  var isChecked = _ref26.isChecked,
      disabled = _ref26.disabled;
  return !isChecked && !disabled && "\n          border: 1px solid #18181E;\n      ";
}, _ref27 => {
  var isChecked = _ref27.isChecked,
      disabled = _ref27.disabled;
  return isChecked && !disabled && "\n      border: 1px solid #18181E;\n      color: #fff;\n      background-color: #18181E;\n    ";
}, _ref28 => {
  var disabled = _ref28.disabled,
      disabledItemStyle = _ref28.disabledItemStyle;
  return disabled && "\n      background: linear-gradient(135deg, transparent calc(50% - 1px), #E5E4F4 50%, transparent calc(50% + 1px));\n      color: #70758C;\n      cursor: not-allowed;\n\n      ".concat(disabledItemStyle, ";\n    ");
}, _ref29 => {
  var itemStyle = _ref29.itemStyle;
  return itemStyle;
});
var NestedItemsSectionLabel = styled(Heading).withConfig({
  displayName: "ProductListingFilter__NestedItemsSectionLabel",
  componentId: "sc-o02ape-13"
})(["\n  display: flex;\n  font-size: 12px;\n  line-height: 24px;\n  color: #333;\n  font-weight: bold;\n\n  ", "\n\n  ", ";\n"], mobile(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    font-size: 14px;\n    padding-top: 8px;\n  "]))), _ref30 => {
  var $nestedStyle = _ref30.$nestedStyle;
  return $nestedStyle;
});
var FilterGrid = styled.ul.withConfig({
  displayName: "ProductListingFilter__FilterGrid",
  componentId: "sc-o02ape-14"
})(["\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  text-align: center;\n  padding: 8px 0 16px 16px;\n\n  ", " & {\n    padding: 0 0 16px 0;\n  }\n\n  ", ";\n"], FilterList, _ref31 => {
  var listStyle = _ref31.listStyle;
  return listStyle;
});
var GridItem = styled.li.withConfig({
  displayName: "ProductListingFilter__GridItem",
  componentId: "sc-o02ape-15"
})(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  margin: 0 3px 3px 0;\n  color: ", ";\n\n  ", ";\n"], _ref32 => {
  var disabled = _ref32.disabled;
  return disabled ? '#ccc' : '#333';
}, _ref33 => {
  var itemStyle = _ref33.itemStyle;
  return itemStyle;
});
var GridItemLabel = styled.label.withConfig({
  displayName: "ProductListingFilter__GridItemLabel",
  componentId: "sc-o02ape-16"
})(["\n  font-size: 16px;\n  letter-spacing: ", "em;\n  text-align: center;\n  right: 0;\n  left: 0;\n  position: absolute;\n\n  ", ";\n"], -0.4 / 16, _ref34 => {
  var gridLabelStyle = _ref34.gridLabelStyle;
  return gridLabelStyle;
});
var FilterCountLabel = styled.span.withConfig({
  displayName: "ProductListingFilter__FilterCountLabel",
  componentId: "sc-o02ape-17"
})(["\n  ", ";\n"], _ref35 => {
  var filterItemCountStyle = _ref35.filterItemCountStyle;
  return filterItemCountStyle;
});
var GridItemCheckbox = styled(Checkbox).attrs(props => {
  return {
    checkmarkStyle: props.checkmarkStyle || gridCheckmarkStyle,
    inputCheckedStyle: props.inputCheckedStyle || gridInputCheckedStyle
  };
}).withConfig({
  displayName: "ProductListingFilter__GridItemCheckbox",
  componentId: "sc-o02ape-18"
})(["\n  width: 56px;\n  height: 56px;\n  margin: 0;\n  border-radius: 0;\n  border: none;\n  line-height: 56px;\n  background-color: #eee;\n  box-sizing: border-box;\n\n  ", ";\n"], _ref36 => {
  var disabled = _ref36.disabled;
  return disabled && css(["\n      border: solid 1px #eee;\n      background-color: #fff;\n    "]);
});
var EmptyMessage = styled.p.withConfig({
  displayName: "ProductListingFilter__EmptyMessage",
  componentId: "sc-o02ape-19"
})(["\n  padding: 0 0 16px 0;\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 24px;\n  text-align: left;\n  color: #333;\n\n  ", "\n"], mobile(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    font-size: 14px;\n  "]))));
var ToggleIcon = styled.svg.withConfig({
  displayName: "ProductListingFilter__ToggleIcon",
  componentId: "sc-o02ape-20"
})(["\n  flex: 0 0 auto;\n"]);
var DynamicFormattedMessage = FormattedMessage;
var FilterListItem = /*#__PURE__*/React.memo(_ref37 => {
  var filterField = _ref37.filterField,
      checkboxProps = _ref37.checkboxProps,
      circleIconStyle = _ref37.circleIconStyle,
      swatchCheckboxProps = _ref37.swatchCheckboxProps,
      colorSwatches = _ref37.colorSwatches,
      filter = _ref37.filter,
      filterItemCountStyle = _ref37.filterItemCountStyle,
      filterLabelOptions = _ref37.filterLabelOptions,
      filterStyle = _ref37.filterStyle,
      gridCheckboxProps = _ref37.gridCheckboxProps,
      gridLabelStyle = _ref37.gridLabelStyle,
      itemLabelStyle = _ref37.itemLabelStyle,
      itemStyle = _ref37.itemStyle,
      disabledItemStyle = _ref37.disabledItemStyle,
      onChange = _ref37.onChange,
      selectedFilters = _ref37.selectedFilters,
      getSwatchIcon = _ref37.getSwatchIcon,
      filterLabel = _ref37.label,
      renderLabel = _ref37.renderLabel,
      _ref37$showFilterItem = _ref37.showFilterItemCount,
      showFilterItemCount = _ref37$showFilterItem === void 0 ? false : _ref37$showFilterItem;
  var checkboxId = useId();
  var label = filter.label || filter.value.toString(); // optional value to be appended to the filter's label, between parenthesis. e.g. Blue (12)

  var filterItemCount = filter.filterCount;
  var filterFieldKey = "filter-".concat(slugify(filterField.field, '-'), "-option");

  if (swatchCheckboxProps && (filterStyle === ProductListingFilterStyle.SWATCH || filterStyle === ProductListingFilterStyle.SWATCH_GRID)) {
    checkboxProps = _objectSpread(_objectSpread({}, checkboxProps), swatchCheckboxProps);
  }

  var hasFilterItems = filter.backgroundCount == null || filter.backgroundCount > 0;
  var isChecked = Array.isArray(selectedFilters) ? selectedFilters.includes(filter.value) : selectedFilters === filter.value;
  var handleChange = useCallback(event => {
    onChange({
      event,
      filterField,
      filter
    });
  }, [filterField, filter, onChange]);

  var renderSwatchIcon = () => {
    return getSwatchIcon ? getSwatchIcon({
      value: filter.value,
      isChecked
    }) : /*#__PURE__*/React.createElement(CircleIcon, {
      value: filter.value,
      colorSwatches: colorSwatches,
      showBorder: label === 'White',
      circleIconStyle: circleIconStyle
    });
  };

  if (filterStyle === ProductListingFilterStyle.GRID) {
    if (filterField.bandSizeCheckboxProps) {
      gridCheckboxProps = _objectSpread(_objectSpread({}, gridCheckboxProps), filterField.bandSizeCheckboxProps);
    } else if (filterField.cupSizeCheckboxProps) {
      gridCheckboxProps = _objectSpread(_objectSpread({}, gridCheckboxProps), filterField.cupSizeCheckboxProps);
    }

    return /*#__PURE__*/React.createElement(GridItem, {
      key: filter.value,
      disabled: !hasFilterItems,
      "data-autotag": filterFieldKey,
      itemStyle: itemStyle,
      disabledItemStyle: disabledItemStyle
    }, /*#__PURE__*/React.createElement(GridItemCheckbox, _extends({
      checked: isChecked,
      disabled: !hasFilterItems,
      id: checkboxId,
      name: filterFieldKey,
      value: filter.value,
      onChange: handleChange,
      variant: "categoryFilterGridCheck"
    }, gridCheckboxProps)), /*#__PURE__*/React.createElement(GridItemLabel, {
      htmlFor: checkboxId,
      isChecked: isChecked,
      gridLabelStyle: gridLabelStyle
    }, renderLabel(filterField, filter, filterLabelOptions), showFilterItemCount && filterItemCount && /*#__PURE__*/React.createElement(FilterCountLabel, {
      filterItemCountStyle: filterItemCountStyle
    }, "\xA0(", filterItemCount, ")")));
  }

  if (filterStyle === ProductListingFilterStyle.SWATCH_GRID) {
    return /*#__PURE__*/React.createElement(SwatchGridFilterItem, {
      key: filter.value,
      disabled: !hasFilterItems,
      "data-autotag": filterFieldKey,
      itemStyle: itemStyle,
      isChecked: isChecked,
      colorSwatches: colorSwatches,
      colorValue: filter.value,
      disabledItemStyle: disabledItemStyle
    }, /*#__PURE__*/React.createElement(FilterItemLabel, {
      htmlFor: checkboxId,
      isChecked: isChecked,
      itemLabelStyle: itemLabelStyle
    }, renderSwatchIcon(), /*#__PURE__*/React.createElement("div", null, renderLabel(filterField, filter, filterLabelOptions), showFilterItemCount && filterItemCount && /*#__PURE__*/React.createElement(FilterCountLabel, {
      filterItemCountStyle: filterItemCountStyle
    }, "\xA0(", filterItemCount, ")"))), /*#__PURE__*/React.createElement(FilterCheckbox, _extends({
      checked: isChecked,
      disabled: !hasFilterItems,
      id: checkboxId,
      name: filterFieldKey,
      value: filter.value,
      onChange: handleChange,
      variant: "categoryFilterCheck"
    }, checkboxProps)));
  }

  if (filterStyle === ProductListingFilterStyle.TAGS_GRID) {
    return /*#__PURE__*/React.createElement(TagsGridFilterItem, {
      key: filter.value,
      disabled: !hasFilterItems,
      "data-autotag": filterFieldKey,
      itemStyle: itemStyle,
      isChecked: isChecked,
      disabledItemStyle: disabledItemStyle
    }, /*#__PURE__*/React.createElement(FilterItemLabel, {
      htmlFor: checkboxId,
      isChecked: isChecked,
      itemLabelStyle: itemLabelStyle
    }, renderLabel(filterField, filter, filterLabelOptions), showFilterItemCount && filterItemCount && /*#__PURE__*/React.createElement(FilterCountLabel, {
      filterItemCountStyle: filterItemCountStyle
    }, "\xA0(", filterItemCount, ")")), /*#__PURE__*/React.createElement(FilterCheckbox, _extends({
      checked: isChecked,
      disabled: !hasFilterItems,
      id: checkboxId,
      name: filterFieldKey,
      value: filter.value,
      onChange: handleChange,
      variant: "categoryFilterCheck"
    }, checkboxProps)));
  }

  return /*#__PURE__*/React.createElement(FilterItem, {
    key: filter.value,
    disabled: !hasFilterItems,
    "data-autotag": filterFieldKey,
    itemStyle: itemStyle
  }, /*#__PURE__*/React.createElement(FilterCheckbox, _extends({
    checked: isChecked,
    disabled: !hasFilterItems,
    id: checkboxId,
    name: filterFieldKey,
    value: filter.value,
    onChange: handleChange,
    variant: "categoryFilterCheck"
  }, checkboxProps)), /*#__PURE__*/React.createElement(FilterItemLabel, {
    htmlFor: checkboxId,
    isChecked: isChecked,
    itemLabelStyle: itemLabelStyle
  }, filterStyle === ProductListingFilterStyle.SWATCH && renderSwatchIcon(), renderLabel(filterField, filter, filterLabelOptions), showFilterItemCount && filterItemCount && /*#__PURE__*/React.createElement(FilterCountLabel, {
    filterItemCountStyle: filterItemCountStyle
  }, "\xA0(", filterItemCount, ")")));
});
FilterListItem.displayName = 'FilterListItem';
FilterListItem.propTypes = {
  checkboxProps: PropTypes.object,
  circleIconStyle: PropTypes.any,
  colorSwatches: PropTypes.object,
  disabledItemStyle: PropTypes.any,
  filter: PropTypes.object,
  filterField: PropTypes.shape({
    bandSizeCheckboxProps: PropTypes.object,
    cupSizeCheckboxProps: PropTypes.object,
    field: PropTypes.string,
    label: PropTypes.string,
    totalAggregationCount: PropTypes.number,
    items: PropTypes.array
  }),
  filterItemCountStyle: PropTypes.any,
  filterLabelOptions: PropTypes.shape({
    labelType: PropTypes.string,
    filterStyle: PropTypes.any
  }),
  filterStyle: PropTypes.oneOf([ProductListingFilterStyle.DEFAULT, ProductListingFilterStyle.GRID, ProductListingFilterStyle.SWATCH, ProductListingFilterStyle.SWATCH_GRID, ProductListingFilterStyle.TAGS_GRID]),
  getSwatchIcon: PropTypes.func,
  gridCheckboxProps: PropTypes.object,
  gridLabelStyle: PropTypes.any,
  itemLabelStyle: PropTypes.any,
  itemStyle: PropTypes.any,
  label: PropTypes.string,
  onChange: PropTypes.func,
  renderLabel: PropTypes.func,
  selectedFilters: PropTypes.any,
  showFilterItemCount: PropTypes.bool,
  swatchCheckboxProps: PropTypes.object
};
export default function ProductListingFilter(_ref38) {
  var _filterContext;

  var filterField = _ref38.filterField,
      filterFieldLabelStyle = _ref38.filterFieldLabelStyle,
      checkboxProps = _ref38.checkboxProps,
      circleIconStyle = _ref38.circleIconStyle,
      _ref38$collapseIconCo = _ref38.collapseIconComponent,
      collapseIconComponent = _ref38$collapseIconCo === void 0 ? MdRemove : _ref38$collapseIconCo,
      colorSwatches = _ref38.colorSwatches,
      disabledItemStyle = _ref38.disabledItemStyle,
      disabledGridItemStyle = _ref38.disabledGridItemStyle,
      disabledSwatchItemStyle = _ref38.disabledSwatchItemStyle,
      disabledSwatchGridItemStyle = _ref38.disabledSwatchGridItemStyle,
      disabledTagsGridItemStyle = _ref38.disabledTagsGridItemStyle,
      _ref38$expandIconComp = _ref38.expandIconComponent,
      expandIconComponent = _ref38$expandIconComp === void 0 ? MdAdd : _ref38$expandIconComp,
      filterCountStyle = _ref38.filterCountStyle,
      filterStyleFromProps = _ref38.filterStyle,
      gridCheckboxProps = _ref38.gridCheckboxProps,
      gridItemStyle = _ref38.gridItemStyle,
      gridLabelStyle = _ref38.gridLabelStyle,
      gridListStyle = _ref38.gridListStyle,
      filterItemCountStyle = _ref38.filterItemCountStyle,
      filterFieldButtonStyle = _ref38.filterFieldButtonStyle,
      filterFieldLabelContainerStyle = _ref38.filterFieldLabelContainerStyle,
      itemLabelStyle = _ref38.itemLabelStyle,
      itemStyle = _ref38.itemStyle,
      label = _ref38.label,
      labelType = _ref38.labelType,
      listStyle = _ref38.listStyle,
      nestedListStyle = _ref38.nestedListStyle,
      nestedHeadingStyle = _ref38.nestedHeadingStyle,
      onChange = _ref38.onChange,
      renderCollapsibleContent = _ref38.renderCollapsibleContent,
      renderFilter = _ref38.renderFilter,
      renderSummary = _ref38.renderSummary,
      selectedFilters = _ref38.selectedFilters,
      _ref38$showFilterItem = _ref38.showFilterItemCount,
      showFilterItemCount = _ref38$showFilterItem === void 0 ? false : _ref38$showFilterItem,
      swatchCheckboxProps = _ref38.swatchCheckboxProps,
      swatchItemStyle = _ref38.swatchItemStyle,
      swatchLabelStyle = _ref38.swatchLabelStyle,
      swatchListStyle = _ref38.swatchListStyle,
      swatchGridItemStyle = _ref38.swatchGridItemStyle,
      swatchGridLabelStyle = _ref38.swatchGridLabelStyle,
      swatchGridListStyle = _ref38.swatchGridListStyle,
      tagsGridItemStyle = _ref38.tagsGridItemStyle,
      tagsGridLabelStyle = _ref38.tagsGridLabelStyle,
      tagsGridListStyle = _ref38.tagsGridListStyle,
      getSwatchIcon = _ref38.getSwatchIcon,
      rest = _objectWithoutProperties(_ref38, ["filterField", "filterFieldLabelStyle", "checkboxProps", "circleIconStyle", "collapseIconComponent", "colorSwatches", "disabledItemStyle", "disabledGridItemStyle", "disabledSwatchItemStyle", "disabledSwatchGridItemStyle", "disabledTagsGridItemStyle", "expandIconComponent", "filterCountStyle", "filterStyle", "gridCheckboxProps", "gridItemStyle", "gridLabelStyle", "gridListStyle", "filterItemCountStyle", "filterFieldButtonStyle", "filterFieldLabelContainerStyle", "itemLabelStyle", "itemStyle", "label", "labelType", "listStyle", "nestedListStyle", "nestedHeadingStyle", "onChange", "renderCollapsibleContent", "renderFilter", "renderSummary", "selectedFilters", "showFilterItemCount", "swatchCheckboxProps", "swatchItemStyle", "swatchLabelStyle", "swatchListStyle", "swatchGridItemStyle", "swatchGridLabelStyle", "swatchGridListStyle", "tagsGridItemStyle", "tagsGridLabelStyle", "tagsGridListStyle", "getSwatchIcon"]);

  var _useBreakpoint = useBreakpoint(),
      isMobile = _useBreakpoint.isMobile; // These two contexts are identical for the purposes of what this
  // component does with them, but we need to check both to maintain
  // backwards compatibility.


  var filterContext = useProductFilters();
  var customFilterContext = useProductFiltersCustomFilters();
  filterContext = filterContext || customFilterContext;
  var filterFieldLabelCtx = FilterFieldLabelProvider.useLabels();
  var optionLabelCtx = OptionLabelProvider.useLabels();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpenFromState = _useState2[0],
      setIsOpen = _useState2[1];

  var isOpenFromContext = (_filterContext = filterContext) === null || _filterContext === void 0 ? void 0 : _filterContext.expandedCollapsibleFilters[filterField.field];
  var isOpen = filterContext ? isOpenFromContext : isOpenFromState;

  if (typeof selectedFilters === 'function') {
    if (filterContext) {
      selectedFilters = selectedFilters(filterContext.selectedFilters);
    } else {
      selectedFilters = selectedFilters();
    }
  } else if (!selectedFilters) {
    selectedFilters = filterContext.selectedFilters;
  }

  var countFilters = useCallback(filterField => {
    // Allow filter fields to override the # of filters they have applied.
    if (filterField.filterCount != null) {
      return filterField.filterCount;
    }

    var values = selectedFilters[filterField.field];

    if (Array.isArray(values)) {
      return values.length;
    }

    return values == null ? 0 : 1;
  }, [selectedFilters]);
  var filterCount = useMemo(() => {
    if (filterField.nestedFilters) {
      return filterField.nestedFilters.reduce((total, subFilter) => total + countFilters(subFilter), 0);
    }

    return countFilters(filterField);
  }, [filterField, countFilters]);
  var singleFilterItem = useMemo(() => {
    if (filterField.nestedFilters) {
      return null;
    }

    var value = selectedFilters[filterField.field];

    if (Array.isArray(value)) {
      return null;
    }

    if (value != null) {
      return filterField.items.find(item => item.value === value);
    }
  }, [filterField.field, filterField.items, filterField.nestedFilters, selectedFilters]);
  var getFilterStyle = useCallback(filterField => {
    if (filterStyleFromProps) {
      return filterStyleFromProps;
    }

    if (filterField.filterStyle) {
      return filterField.filterStyle;
    }

    var isLongFilterLabel = item => {
      var label = item.label || item.value.toString();

      if (typeof label === 'string') {
        return label.length > 4;
      }

      return false;
    };

    var hasLongFilterLabel = filterField.items.some(isLongFilterLabel);

    switch (filterField.field) {
      case 'color':
        return ProductListingFilterStyle.SWATCH;

      case 'size_bottom':
      case 'size_bra':
      case 'size_top':
      case 'size_denim':
      case 'size':
        return isMobile && !hasLongFilterLabel ? ProductListingFilterStyle.GRID : ProductListingFilterStyle.DEFAULT;

      default:
        return ProductListingFilterStyle.DEFAULT;
    }
  }, [filterStyleFromProps, isMobile]);

  var getItemStyle = filterStyle => {
    switch (filterStyle) {
      case ProductListingFilterStyle.SWATCH:
        return swatchItemStyle;

      case ProductListingFilterStyle.SWATCH_GRID:
        return swatchGridItemStyle;

      case ProductListingFilterStyle.TAGS_GRID:
        return tagsGridItemStyle;

      case ProductListingFilterStyle.GRID:
        return gridItemStyle;

      case ProductListingFilterStyle.DEFAULT:
        return itemStyle;

      default:
        return itemStyle;
    }
  };

  var getDisabledItemStyle = filterStyle => {
    switch (filterStyle) {
      case ProductListingFilterStyle.SWATCH:
        return disabledSwatchItemStyle;

      case ProductListingFilterStyle.SWATCH_GRID:
        return disabledSwatchGridItemStyle;

      case ProductListingFilterStyle.TAGS_GRID:
        return disabledTagsGridItemStyle;

      case ProductListingFilterStyle.GRID:
        return disabledGridItemStyle;

      case ProductListingFilterStyle.DEFAULT:
        return disabledItemStyle;

      default:
        return disabledItemStyle;
    }
  };

  var getItemLabelStyle = filterStyle => {
    switch (filterStyle) {
      case ProductListingFilterStyle.SWATCH:
        return swatchLabelStyle;

      case ProductListingFilterStyle.SWATCH_GRID:
        return swatchGridLabelStyle;

      case ProductListingFilterStyle.TAGS_GRID:
        return tagsGridLabelStyle;

      case ProductListingFilterStyle.GRID:
        return gridLabelStyle;

      case ProductListingFilterStyle.DEFAULT:
        return itemLabelStyle;

      default:
        return itemLabelStyle;
    }
  };

  var getListStyle = filterStyle => {
    switch (filterStyle) {
      case ProductListingFilterStyle.SWATCH:
        return swatchListStyle;

      case ProductListingFilterStyle.SWATCH_GRID:
        return swatchGridListStyle;

      case ProductListingFilterStyle.TAGS_GRID:
        return tagsGridListStyle;

      case ProductListingFilterStyle.GRID:
        return gridListStyle;

      case ProductListingFilterStyle.DEFAULT:
        return listStyle;

      default:
        return listStyle;
    }
  };

  var getListComponent = filterStyle => {
    switch (filterStyle) {
      case ProductListingFilterStyle.GRID:
        return FilterGrid;

      case ProductListingFilterStyle.TAGS_GRID:
      case ProductListingFilterStyle.SWATCH_GRID:
        return FilterWrappedList;

      default:
        return FilterList;
    }
  };

  var labelOptions = {
    labelType: labelType || LabelType.PRODUCT_FILTER
  };
  var handleFilterFieldClick = useCallback(() => filterContext ? filterContext.toggleCollapsibleFilterIsOpen({
    type: 'toggle',
    filterField: filterField.field
  }) : setIsOpen(prevOpen => !prevOpen), [filterContext, filterField]);
  var handleChange = useCallback(_ref39 => {
    var event = _ref39.event,
        filterField = _ref39.filterField,
        filter = _ref39.filter;
    // only gives us the current filter item
    var newSelectedFilters; // gives us all new filter values by filter field

    var newAllSelectedFilters = _objectSpread({}, selectedFilters);

    var oldSelectedFilters = selectedFilters[filterField.field];

    if (Array.isArray(oldSelectedFilters)) {
      if (event.target.checked) {
        newSelectedFilters = [...selectedFilters[filterField.field], filter.value];

        if (event.target.type === 'radio') {
          newSelectedFilters = [filter.value];
        }
      } else {
        newSelectedFilters = selectedFilters[filterField.field].filter(filterItem => filterItem !== filter.value);
      }
    } else {
      newSelectedFilters = event.target.checked ? filter.value : null;
    }

    newAllSelectedFilters[filterField.field] = newSelectedFilters;
    onChange({
      event,
      filterField,
      newSelectedFilters,
      newSelectedFilterValue: filter.value,
      newAllSelectedFilters,
      // pass the entire filter object, so we can define our own callbacks outside the lib
      filterObject: filter
    });
  }, [onChange, selectedFilters]);

  var renderFilterList = function renderFilterList(filterField) {
    var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if (filterField.nestedFilters) {
      return /*#__PURE__*/React.createElement(FilterList, {
        depth: depth,
        listStyle: nestedListStyle
      }, filterField.nestedFilters.filter(subFilter => subFilter.totalAggregationCount !== 0 || subFilter.emptyMessage).map(subFilter => /*#__PURE__*/React.createElement("li", {
        key: subFilter.field
      }, /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(NestedItemsSectionLabel, {
        $nestedStyle: nestedHeadingStyle
      }, filterFieldLabelCtx.renderLabel(subFilter, labelOptions)), renderFilterList(subFilter, depth + 1)))));
    }

    if (!filterField.items.length && filterField.emptyMessage) {
      return /*#__PURE__*/React.createElement(EmptyMessage, null, filterField.emptyMessage);
    }

    var filterStyle = getFilterStyle(filterField);
    var listStyle = getListStyle(filterStyle);
    var itemStyle = getItemStyle(filterStyle);
    var disabledItemStyle = getDisabledItemStyle(filterStyle);
    var itemLabelStyle = getItemLabelStyle(filterStyle);
    var ListComponent = getListComponent(filterStyle);
    return /*#__PURE__*/React.createElement(ListComponent, {
      depth: depth,
      listStyle: listStyle
    }, filterField.items.map(filter => {
      var filterLabelOptions = {
        labelType: labelType || LabelType.PRODUCT_FILTER,
        filterStyle
      };
      var filterLabel = optionLabelCtx.renderLabelString(filterField, filter, filterLabelOptions);

      var renderLabel = (filterField, filter, labelOptions) => optionLabelCtx.renderLabel(filterField, filter, labelOptions);

      return /*#__PURE__*/React.createElement(FilterListItem, {
        filterField: filterField,
        checkboxProps: checkboxProps,
        swatchCheckboxProps: swatchCheckboxProps,
        colorSwatches: colorSwatches,
        filter: filter,
        filterStyle: filterStyle,
        key: filter.value,
        gridCheckboxProps: gridCheckboxProps,
        gridLabelStyle: gridLabelStyle,
        itemLabelStyle: itemLabelStyle,
        itemStyle: itemStyle,
        disabledItemStyle: disabledItemStyle,
        onChange: handleChange,
        selectedFilters: selectedFilters[filterField.field],
        circleIconStyle: circleIconStyle,
        filterLabelOptions: filterLabelOptions,
        getSwatchIcon: getSwatchIcon,
        label: filterLabel,
        renderLabel: renderLabel,
        showFilterItemCount: showFilterItemCount,
        filterItemCountStyle: filterItemCountStyle
      });
    }));
  };

  var autotagKey = slugify(filterField.label, '-');

  if (!renderSummary) {
    renderSummary = () => {
      if (singleFilterItem) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, ' (', optionLabelCtx.renderLabel(filterField, singleFilterItem, _objectSpread(_objectSpread({}, labelOptions), {}, {
          labelType: LabelType.PRODUCT_FILTER_SUMMARY
        })), ')');
      } else if (filterCount > 0) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement(DynamicFormattedMessage, {
          id: "site_product_filter.filter_count",
          defaultMessage: "({filterCount})",
          filterFieldButtonStyle: filterFieldButtonStyle,
          values: {
            filterCount: /*#__PURE__*/React.createElement(FormattedNumber, {
              value: filterCount
            })
          }
        }));
      } else {
        return null;
      }
    };
  }

  var summaryContent = renderSummary({
    filterField,
    selectedFilters
  });
  return /*#__PURE__*/React.createElement(Wrapper, rest, /*#__PURE__*/React.createElement(Collapsible, {
    isOpen: isOpen,
    defaultOpen: false
  }, /*#__PURE__*/React.createElement(FilterFieldButton, {
    $filterFieldButtonStyle: filterFieldButtonStyle,
    onClick: handleFilterFieldClick,
    "data-autotag": "filter-".concat(autotagKey)
  }, /*#__PURE__*/React.createElement(FilterFieldLabel, {
    labelContainerStyle: filterFieldLabelContainerStyle
  }, /*#__PURE__*/React.createElement(FilterFieldLabelText, {
    labelStyle: filterFieldLabelStyle
  }, label || filterFieldLabelCtx.renderLabel(filterField, labelOptions)), summaryContent != null ? /*#__PURE__*/React.createElement(FilterValueSummary, {
    filterCountStyle: filterCountStyle
  }, summaryContent) : null), isOpen ? /*#__PURE__*/React.createElement(ToggleIcon, {
    as: collapseIconComponent,
    "data-autotag": "filter-".concat(autotagKey, "-collapse")
  }) : /*#__PURE__*/React.createElement(ToggleIcon, {
    as: expandIconComponent,
    "data-autotag": "filter-".concat(autotagKey, "-expand")
  })), /*#__PURE__*/React.createElement(Collapsible.Content, {
    mountOnEnter: true,
    unmountOnExit: true
  }, renderCollapsibleContent ? renderCollapsibleContent({
    filterField,
    labelType,
    onChange,
    selectedFilters
  }) : null, renderFilter ? renderFilter({
    filterField,
    labelType,
    onChange,
    selectedFilters
  }) : renderFilterList(filterField))));
}
var filterStylePropType = PropTypes.oneOf([ProductListingFilterStyle.DEFAULT, ProductListingFilterStyle.GRID, ProductListingFilterStyle.SWATCH, ProductListingFilterStyle.SWATCH_GRID, ProductListingFilterStyle.TAGS_GRID]);
ProductListingFilter.propTypes = {
  checkboxProps: PropTypes.object,
  circleIconStyle: PropTypes.any,
  collapseIconComponent: PropTypes.elementType,
  colorSwatches: PropTypes.object,
  disabledGridItemStyle: PropTypes.any,
  disabledItemStyle: PropTypes.any,
  disabledSwatchGridItemStyle: PropTypes.any,
  disabledSwatchItemStyle: PropTypes.any,
  disabledTagsGridItemStyle: PropTypes.any,
  expandIconComponent: PropTypes.elementType,
  filterCount: PropTypes.number,
  filterCountStyle: PropTypes.any,
  filterField: PropTypes.shape({
    field: PropTypes.string,
    label: PropTypes.string,
    totalAggregationCount: PropTypes.number,
    nestedFilters: PropTypes.array,
    items: PropTypes.array,
    emptyMessage: PropTypes.node,
    filterCount: PropTypes.number,
    filterStyle: filterStylePropType
  }),
  filterFieldButtonStyle: PropTypes.any,
  filterFieldLabelContainerStyle: PropTypes.any,
  filterFieldLabelStyle: PropTypes.any,
  filterItemCountStyle: PropTypes.any,
  filterStyle: filterStylePropType,
  getSwatchIcon: PropTypes.func,
  gridCheckboxProps: PropTypes.object,
  gridItemStyle: PropTypes.any,
  gridLabelStyle: PropTypes.any,
  gridListStyle: PropTypes.any,
  itemLabelStyle: PropTypes.any,
  itemStyle: PropTypes.any,

  /**
   * Custom label to render for the collapsible button. Defaults to category label.
   */
  label: PropTypes.node,
  labelType: PropTypes.string,
  listStyle: PropTypes.any,
  nestedHeadingStyle: PropTypes.any,
  nestedListStyle: PropTypes.any,
  onChange: PropTypes.func,
  renderCollapsibleContent: PropTypes.func,
  renderFilter: PropTypes.func,
  renderSummary: PropTypes.func,
  selectedFilters: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  showFilterItemCount: PropTypes.bool,
  swatchCheckboxProps: PropTypes.object,
  swatchGridItemStyle: PropTypes.any,
  swatchGridLabelStyle: PropTypes.any,
  swatchGridListStyle: PropTypes.any,
  swatchItemStyle: PropTypes.any,
  swatchLabelStyle: PropTypes.any,
  swatchListStyle: PropTypes.any,
  tagsGridItemStyle: PropTypes.any,
  tagsGridLabelStyle: PropTypes.any,
  tagsGridListStyle: PropTypes.any
};
/**
 * Exporting `BandSize` here to allow brands to custom style the component.
 * Needed to be exported via the `ProductListingFilter` container component rather than directly from `ProductSizeFilter` for it to work.
 */

ProductListingFilter.BandSize = ProductSizeFilter.BandSize;
ProductListingFilter.SwatchGridFilterItem = SwatchGridFilterItem;
ProductListingFilter.CircleIcon = CircleIcon;
ProductListingFilter.TagsGridFilterItem = TagsGridFilterItem;
ProductListingFilter.FilterItemLabel = FilterItemLabel;
ProductListingFilter.FilterCheckbox = FilterCheckbox;